import { Container, Row, Col } from 'reactstrap'
import React, { useState } from 'react';
import {Navigate, NavLink} from 'react-router-dom';

import {Dropdown, DropdownToggle, DropdownMenu, DropdownItem,} from 'reactstrap';

import { useSelector, useDispatch } from 'react-redux';

import { authActions } from '../_services/essentials/store';
import {history} from "../_services/essentials/helpers";
import '../index.css'
export { AppHeader };

function AppHeader() {
    const auth = useSelector(x => x.auth.value);
    const dispatch = useDispatch();
    const logout = () => dispatch(authActions.logout());
    const currentTitle = useSelector(x => x.breadcrumbs.current_title);

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);

    const loggedInUser = useSelector(x => x.auth.loggedInUser);

    // only show nav when logged in
    if (!auth) {
        return <Navigate to="/account/login" state={{ from: history.location }} />
    }

    return (
        <Container>
            <Row className="app-header-section">
                <Col className="page-title" xs md={4}>
                    {/*
                    <nav className="navbar navbar-expand navbar-dark bg-dark px-3">
                        <div className="navbar-nav">
                            <NavLink to="/home" className="nav-item nav-link">Home</NavLink>
                            <NavLink to="/users" className="nav-item nav-link">Users</NavLink>
                            <button onClick={logout} className="btn btn-link nav-item nav-link">Logout</button>
                        </div>
                    </nav>
                    */}
                    <h5>{currentTitle}</h5>
                </Col>
                <Col xs md={4}>
                </Col>
                <Col xs md={4}>
                    <Row>
                        <Col xs md={4}></Col>
                        <Col xs md={8} className="user-menu">
                            <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={"down"}>
                                <DropdownToggle caret>{loggedInUser?.firstname}</DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header></DropdownItem>
                                    <DropdownItem><NavLink to={`/users/edit/${loggedInUser?.id}`} className="nav-item nav-link">Profile</NavLink></DropdownItem>
                                    {/*<DropdownItem text>Dropdown Item Text</DropdownItem>*/}
                                    {/*<DropdownItem disabled>Action (disabled)</DropdownItem>*/}
                                    <DropdownItem><NavLink to="/users/change_password" className="nav-item nav-link">Change Password</NavLink></DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem><button onClick={logout} className="btn btn-link nav-item nav-link">Logout</button></DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                            {/*
                            <nav className="navbar navbar-expand px-3">
                                <div className="navbar-nav">
                                    <button onClick={logout} className="btn btn-link nav-item nav-link">Logout</button>
                                </div>
                            </nav>
                            */}
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Container>
    );
}